import React from "react";
import { RotateCcw } from "lucide-react";

const ErrorState = ({ theme, isRTL, title, description, retryLabel, onRetry }) => {
  const isDark = theme === "dark";
  const stroke = isDark ? "rgba(248,113,113,0.6)" : "rgba(239,68,68,0.5)";
  const fill = isDark ? "rgba(239,68,68,0.1)" : "rgba(239,68,68,0.06)";

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "56px 24px", textAlign: "center" }}>
      <svg width="120" height="100" viewBox="0 0 120 100" fill="none" style={{ marginBottom: 20 }}>
        <path d="M60 12 L112 88 L8 88 Z" fill={fill} stroke={stroke} strokeWidth="2.5" strokeLinejoin="round" />
        <line x1="60" y1="42" x2="60" y2="64" stroke="#ef4444" strokeWidth="3.5" strokeLinecap="round" />
        <circle cx="60" cy="76" r="2.5" fill="#ef4444" />
      </svg>
      <h3 style={{ margin: "0 0 8px 0", fontSize: 16, fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b" }}>{title}</h3>
      <p style={{ margin: "0 0 20px 0", fontSize: 13, maxWidth: 320, lineHeight: 1.5, color: isDark ? "rgba(255,255,255,0.5)" : "rgba(30,41,59,0.55)" }}>{description}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            display: "flex", alignItems: "center", gap: 8, padding: "10px 20px", borderRadius: 12,
            border: `1px solid ${isDark ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.1)"}`,
            background: "transparent", color: isDark ? "#f1f5f9" : "#1e293b", fontSize: 13, fontWeight: 700, cursor: "pointer",
            flexDirection: isRTL ? "row-reverse" : "row",
          }}
        >
          <RotateCcw size={15} /> {retryLabel}
        </button>
      )}
    </div>
  );
};

export default ErrorState;
